export default __webpack_public_path__ + "static/media/Acolyte's Boots of the Underworld.fd537660.jpg";